import { PureComponent } from 'react'
import * as cn from 'classnames'
import { Field } from 'redux-form'
import TextFieldWrapped from 'components/atoms/inputs/TextFieldWrapped'
import * as styles from 'components/features/pfm/RedemptionForm/AccountStep.css'
import {
  FIELD_ACCOUNT_NUMBER_PROPS,
  FIELD_ACCOUNT_NUMBER_WRAPPED_PROPS,
  FIELD_ROUTING_NUMBER_PROPS,
  FIELD_ROUTING_NUMBER_WRAPPED_PROPS,
} from 'constants/fields'
import CheckboxWrapped from 'components/atoms/inputs/CheckboxWrapped'
import { parseValueToBoolean } from 'helpers/formHelpers'
import { ReduxFormProps } from 'interfaces/component'
import SubmitButton from 'components/features/pfm/RedemptionForm/SubmitButton'
import CancelButton from 'components/features/pfm/RedemptionForm/CancelButton'
import redemptionReduxForm from 'components/features/pfm/RedemptionForm/redemptionReduxForm'
import { accountStepSchema } from 'schemas/redemptionSchema'
import RadioButtonListWrapped from 'components/atoms/inputs/RadioButtonListWrapped'
import { RedemptionFormValues } from 'interfaces/bounty'
import { redemptionFormFieldNames } from 'components/features/pfm/RedemptionForm/RedemptionForm'

const ACCOUNT_TYPE_ITEMS = [
  { label: 'Checking', value: 'checking' },
  { label: 'Savings', value: 'savings' },
]

type AccountStepProps = ReduxFormProps<RedemptionFormValues> & {
  formValues: RedemptionFormValues
  onRememberChange: (value: boolean) => void
}

class AccountStep extends PureComponent<AccountStepProps> {
  render () {
    return (
      <form onSubmit={ this.props.handleSubmit } className={ styles.accountStep }>
        <div className={ styles.accountTypeWrapper }>
          <Field
            name='bank_account_type'
            props={
              {
                label: redemptionFormFieldNames.bank_account_type,
                items: ACCOUNT_TYPE_ITEMS,
                qaMarker: 'account-type',
                align: 'left',
              }
            }
            component={ RadioButtonListWrapped }
          />
        </div>
        <div className={ styles.fieldWrapper }>
          <Field
            name='account_number'
            component={ TextFieldWrapped }
            props={
              {
                ...FIELD_ACCOUNT_NUMBER_PROPS,
                autoFocus: !this.props.formValues.account_number,
              }
            }
            { ...FIELD_ACCOUNT_NUMBER_WRAPPED_PROPS }
          />
        </div>
        <div className={ styles.fieldWrapper }>
          <Field
            name='routing_number'
            component={ TextFieldWrapped }
            props={ FIELD_ROUTING_NUMBER_PROPS }
            { ...FIELD_ROUTING_NUMBER_WRAPPED_PROPS }
          />
        </div>
        <div className={ styles.fieldWrapper }>
          <Field
            name='remember'
            props={
              {
                label: 'Save this account for future redemptions',
                onValueChange: this.props.onRememberChange,
              }
            }
            component={ CheckboxWrapped }
            parse={ parseValueToBoolean }
          />
        </div>
        <div className={ cn(styles.tooltip, { [styles.hidden]: !this.props.formValues.remember }) }>
          <Field
            name='name'
            props={
              {
                label: redemptionFormFieldNames.name,
                qaMarker: 'account-name',
                placeholder: 'My Checking Account',
              }
            }
            component={ TextFieldWrapped }
          />
        </div>
        <div className={ styles.buttonWrapper }>
          <SubmitButton>Confirm Your Redemption</SubmitButton>
        </div>
        <CancelButton />
      </form>
    )
  }
}

export default redemptionReduxForm(AccountStep, accountStepSchema)
